module.exports = __webpack_public_path__ + "static/media/mini.448064f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/marketingOnline/data/carImages/远程星享/mini.png
// module id = 690
// module chunks = 0